/**
 * User Profile Types
 * User workspace profiles (for agent learning about user roles).
 */

import { z } from 'zod';

export const UserWorkspaceProfileSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  userId: z.string(),
  roleDescription: z.string().optional(),
  expertiseAreas: z.array(z.string()),
  preferences: z.record(z.unknown()).optional(),
  learnings: z.array(z.string()),
});

export type UserWorkspaceProfile = z.infer<typeof UserWorkspaceProfileSchema>;
